import { useQuery } from "@tanstack/react-query";
import apiAttendanceApprovalCount from "../../../../services/manager/attendance/apiAttendanceApprovalCount";

export default function AttendanceApprovalCountQuery() {
  const {
    data,
    isLoading: attendanceApprovalCountLoading,
    refetch: attendanceApprovalCountRefetch,
  } = useQuery({
    queryKey: ["attendanceApprovalCount"],
    queryFn: () => apiAttendanceApprovalCount(),
  });

  const finalApprovalAttendanceCount = data?.data.final_approval_count;
  const directReportAttendanceCount = data?.data.direct_approval_count;

  console.log("attendance count data", data?.data);

  return {
    finalApprovalAttendanceCount,
    directReportAttendanceCount,
    attendanceApprovalCountLoading,
    attendanceApprovalCountRefetch,
  };
}
